import { render, staticRenderFns } from "./BMS.vue?vue&type=template&id=0ada43d8&scoped=true"
import script from "./BMS.vue?vue&type=script&lang=js"
export * from "./BMS.vue?vue&type=script&lang=js"
import style0 from "./BMS.vue?vue&type=style&index=0&id=0ada43d8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ada43d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ada43d8')) {
      api.createRecord('0ada43d8', component.options)
    } else {
      api.reload('0ada43d8', component.options)
    }
    module.hot.accept("./BMS.vue?vue&type=template&id=0ada43d8&scoped=true", function () {
      api.rerender('0ada43d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/softBusinessLogistics/BMS.vue"
export default component.exports